import SpinService from '../../services/spin.service';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const fetchSpinnerContent = createAsyncThunk(
  'spinner/fetchContent',
  async (_, { rejectWithValue }) => {
    try {
      const response = await SpinService.getSpinWheelContent();
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const initialData = {
  nextDailySpinWheelInSeconds: 0
}
const spinnerSlice = createSlice({
  name: 'spinner',
  initialState: {
    data: initialData,
    status: 'idle',
    error: null,
  },
  reducers: {
     tickTimer: (state) => {
      if (!state.data) state.data = { ...initialData };
      if (state.data.nextDailySpinWheelInSeconds > 0) {
        state.data.nextDailySpinWheelInSeconds -= 1;
      }
    },
    setTimer: (state, action) => {
      if (!state.data) state.data = { ...initialData };
      state.data.nextDailySpinWheelInSeconds = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSpinnerContent.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchSpinnerContent.fulfilled, (state, action) => {
        state.status = 'success';
        state.data = action.payload ?? { ...initialData };
      })
      .addCase(fetchSpinnerContent.rejected, (state, action) => {
        state.status = 'error';
        state.error = action.payload;
      });
  },
});

export const { tickTimer, setTimer } = spinnerSlice.actions;
export default spinnerSlice.reducer;
